exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".glimpse-into{width:100%;background-color:#ffff;display:flex;flex-direction:column;margin:5% 0%}.glimpse-into .title{padding:0}.glimpse-into .video-slider iframe{width:50% !important;margin-left:25%}.glimpse-into .video-slider .slick-dots li button:before{font-size:15px}@media (max-width: 767px){.glimpse-into{width:100%;background-color:#ffff;display:flex;flex-direction:column;margin:5% 0%}.glimpse-into .title{padding:0}.glimpse-into .video-slider iframe{width:100% !important;margin-left:0}}\n", ""]);

// exports
